var LegacyGrainPricePage = LegacyGrainPricePage || (function () {
    var getPricePeriods = function (area, itemNumber, sort, date) {
        var tableResult = $("#legacy-price-period-result");
        $("#legacy-loader").show();
        var pageId = $("#legacy-page-id").data("page-id");

        var priceSearch = {
            Area: area,
            ItemNumber: itemNumber,
            Sort: sort,
            Date: date,
            PageId: pageId
        };

        $.ajax({
            type: 'POST',
            url: '/api/legacy/price-grain/GetPricePeriods',
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(priceSearch),
            success: function (response) {
                if (!response) {
                    tableResult.html("<div>Det finns inga aktuella priser för valt område och gröda/sort.</div>");
                } else {
                    tableResult.html(response);
                }
            },
            error: function () {
                tableResult.html("<div>Det finns inga aktuella priser för valt område och gröda/sort.</div>");
            },
            complete: function () {
                $("#legacy-loader").hide();
            }
        });
    };

    var getGrainTypesForProduct = function (itemnumber) {
        $('#legacy-grain-type-list .dropdown').html('');
        $.ajax({
            dataType: "json",
            type: 'get',
            url: '/api/legacy/price-grain/get-grain-type-by-product',
            data: { itemnumber: itemnumber },
            cache: false,
            success: function (data) {
                if (data.Data.length > 0) {
                    data.Data.forEach((item) => {
                        const name = item.NameDescription && item.NameDescription.length
                            ? item.NameDescription
                            : item.Name;
                        $('#legacy-grain-type-list .dropdown').append(`<li data-value="${item.Name}"><a href="javascript:void(0)">${name}</a></li>`);
                    });
                    setDropdown($('.grain-Type-Dropdown'), 'type-3');
                }
            },
            error: function () { },
            complete: function () { $('#legacy-loader').hide(); }
        });
    };

    var showGrainPriceClickEvent = function () {
        $("#legacy-btnShowGrainPrices").on("click", function () {
            var priceAreaId = $('#legacy-price-area-list').attr('data-value');
            var itemNumber = $('#legacy-product-list').attr('data-value');
            var sort = $('#legacy-grain-type-list').attr('data-value');
            var date = $("#legacy-price-grain-history").val();
            getPricePeriods(priceAreaId, itemNumber, sort, date);
        });
    };

    var getSortByProductEvent = function () {
        $('#legacy-product-list .dropdown li a').on("click", function () {
            var itemnumber = $(this).parent().attr('data-value');
            $("#legacy-btnShowGrainPrices").attr('disabled', true).removeClass('reverse-state');
            getGrainTypesForProduct(itemnumber);
        });
    };

    var sortClickEvent = function () {
        $(document)
            .off('click.legacyGrainSort')
            .on('click.legacyGrainSort', '#legacy-grain-type-list .dropdown li a', function () {
                var selectedValue = $(this).text(); // Get the selected text
                $("#legacy-btnShowGrainPrices").attr('disabled', false).addClass('reverse-state');
                $('#legacy-grain-type-list').attr('data-value', $(this).parent().attr('data-value'));
                $('#legacy-grain-type-list > a').text(selectedValue); // Update the dropdown display
            });
    };

    var initEvent = function () {
        showGrainPriceClickEvent();
        getSortByProductEvent();
        sortClickEvent();
    };


    // Date(2025, 11, 31) caps datepicker at the 31st of December 2025
    var legacyDateSelector = '#legacy-price-grain-history';
    var legacyDateRange = {
        max: new Date(2025, 11, 31)
    };

    var formatDateForAttribute = function (date) {
        var month = (date.getMonth() + 1).toString().padStart(2, '0');
        var day = date.getDate().toString().padStart(2, '0');
        return date.getFullYear() + '-' + month + '-' + day;
    };

    var applyLegacyBounds = function () {
        var $picker = $(legacyDateSelector);
        if (!$picker.length) {
            return;
        }

        if (legacyDateRange.max) {
            $picker.attr('max', formatDateForAttribute(legacyDateRange.max));
            if ($.fn.datepicker && $picker.hasClass('hasDatepicker')) {
                $picker.datepicker('option', 'maxDate', legacyDateRange.max);
            }
        }
    };

    var init = function () {
        applyLegacyBounds();
        if ($("#legacy-price-period-result").length > 0) {
            initEvent();
        }
    };

    return {
        init: init
    };
})();

$(function () {
    LegacyGrainPricePage.init();
});
